import React from 'react';
import { useSelector } from 'react-redux';
import Stepper from './diy-stepbar/Stepper';
import getSessionTitle from './diy-utils/getSessionTitle';

const DiyStepBar = ({ step, bin }) => {
  const policy = useSelector(state => state.policy);
  const isShippingEnabled = !!policy.id;
  const stepArray = isShippingEnabled ? [1, 2, 3, 4, 5, 6, 7] : [1, 2, 3, 4, 5, 6];
  // if (!bin) {
  //   stepArray.push(7);
  // }
  const stepTitles = [];
  stepArray.forEach(stepNum => stepTitles.push({ title: getSessionTitle({ step: stepNum, bin }) }));

  return <Stepper steps={stepTitles} activeStep={step} />;
};

export default DiyStepBar;
